import HeaderCategoriesPresenter from "./header-categories.js";

import HeaderView from "../view/header.js";
import ListItem from "../view/list-item.js";

import HeaderModel from "../model/header.js";

import {
  removeElement,
  render,
  RenderPosition
} from "../../render/render.js";

import {
  debounce
} from "../../../utils/debounce.js";

import {
  TABLET_MEDIA_QUERY,
  defaultHeaderModelData,
  ActionType
} from "../const.js";

import {
  ADDRESS_BUTTON_TEXT
} from "../lexicon.js";

export default class HeaderLayout {
  constructor(headerElement) {
    this._headerElement = headerElement;

    this._headerCategoriesPresenter = null;

    this._headerView = null;
    this._moreListItemView = null;

    this._headerModel = null;

    this._moreListId = null;

    this._handleWindowResize = this._handleWindowResize.bind(this);
    this._handleChangeData = this._handleChangeData.bind(this);
  }

  init() {
    this._headerView = new HeaderView(this._headerElement);
    this._headerModel = new HeaderModel(Object.assign(
        {},
        defaultHeaderModelData
    ));
    this._headerModel.addObserver(this._handleChangeData);

    this._headerCategoriesPresenter = new HeaderCategoriesPresenter(this._headerView.getCategories());
    this._headerCategoriesPresenter.init();

    if (window.matchMedia(TABLET_MEDIA_QUERY).matches) {
      this._processChangeView();
    }

    window.addEventListener(`resize`, debounce(this._handleWindowResize));
  }

  _processChangeView() {
    if (this._headerModel.getData().isViewChanged) {
      return;
    }

    this._headerModel.changeData(Object.assign(
        {},
        this._headerModel.getData(),
        {
          isViewChanged: true
        }
    ), ActionType.CHANGE_VIEW);
  }

  _processResetView() {
    if (!this._headerModel.getData().isViewChanged) {
      return;
    }

    this._headerModel.changeData(Object.assign(
        {},
        this._headerModel.getData(),
        {
          isViewChanged: false
        }
    ), ActionType.RESET_VIEW);
  }

  _changeView() {
    this._moreListItemView = new ListItem();

    const moreListItemElement = this._moreListItemView.getElement();
    const subMenuElement = this._moreListItemView.getSubMenuElement();

    const menuListElement = this._headerView.getMenuList();
    const lastMenuItemElement = this._headerView.getLastMenuItem();
    const catalogButtonElement = this._headerView.getCatalogButton();
    const searchFormElement = this._headerView.getSearchFormElement();

    render(subMenuElement, lastMenuItemElement);
    render(menuListElement, moreListItemElement);
    render(searchFormElement, catalogButtonElement, RenderPosition.BEFOREBEGIN);

    this._headerView.changeAddressButtonText(ADDRESS_BUTTON_TEXT);

    this._moreListId = this._headerCategoriesPresenter.addCategory(this._moreListItemView.getLinkElement());
  }

  _resetView() {
    const moreListItemElement = this._moreListItemView.getElement();

    const menuListElement = this._headerView.getMenuList();
    const lastMenuItemElement = this._headerView.getLastMenuItem();
    const catalogButtonElement = this._headerView.getCatalogButton();
    const headerListElement = this._headerView.getHeaderListElement();

    render(menuListElement, lastMenuItemElement);
    removeElement(moreListItemElement);

    this._moreListItemView = null;

    render(headerListElement, catalogButtonElement, RenderPosition.AFTERBEGIN);

    this._headerView.resetAddressButtonText();

    this._headerCategoriesPresenter.removeCategory(this._moreListId);
    this._moreListId = null;
  }

  _handleChangeData(action) {
    switch (action) {
      case ActionType.CHANGE_VIEW:
        this._changeView();
        break;
      case ActionType.RESET_VIEW:
        this._resetView();
        break;
    }
  }

  _handleWindowResize() {
    if (window.matchMedia(TABLET_MEDIA_QUERY).matches) {
      this._processChangeView();
    } else {
      this._processResetView();
    }
  }
}
